const chipStatusColor = (status, classes) => {
  if (status) {
    return classes.chipActive
  }
  return classes.chipInactive
}

export default chipStatusColor
